export default "__VITE_ASSET__CwLnRu0T__"